<template>
  <v-fade-transition mode="out-in">
    <router-view />
  </v-fade-transition>
</template>

<script>

export default {
  name: "App",
  components: {
  },
  data() {
    return {

    }
  },
  methods: {
    onSubmit: function () {
      this.$refs.invisibleRecaptcha.execute()
    },
    onVerify: function (response) {
      console.log('Verify: ' + response)
    },
    onExpired: function () {
      console.log('Expired')
    },
    resetRecaptcha() {
      this.$refs.recaptcha.reset() // Direct call reset method
    },
  },
  mounted() {
   
  },
  metaInfo: {
    title: "برکا",
    titleTemplate: "%s | مدیریت آموزش مجازی",
    htmlAttrs: { lang: "en" },
    meta: [
      { charset: "utf-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
    ],
  },

};
</script>
<style>
.text-content-left input {
  text-align: left !important;
}
</style>